import comp from "./StudentTranscriptPreview";
export default comp;
